module.exports = __webpack_public_path__ + "static/media/mx.52933b99.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mx.svg
// module id = 202
// module chunks = 0